module.exports = __webpack_public_path__ + "img/service-parts-grid-tiles-cjdr.d95e94da.png";